import { useTranslation } from "react-i18next";
import "../../scss/freelancing-guide-styling-components/guide-intro.style.scss";
import { rightArrow } from "../images/svg/icons";
import { GuideIntroImage } from "../images/png/icons";
import { services } from "../../constant/Guide-intro.constant";

const GuideIntro = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="guide-intro-container-wrapper">
        <div className="guide-intro-container w-100">
          <div className="header-content w-100 w-sm-50">{t("GUIDE_INTRO_TITLE")}</div>
          <div className="text-content w-100 w-sm-50">{t("GUIDE_INTRO_DESC")}</div>
        </div>
        <div className="guide-intro-container-image">
          <img src={GuideIntroImage} alt={t("GUIDE_INTRO_IMAGE_ALT")} className="guide-intro-image" />
        </div>
      </div>
      <section className="freelance-work-section">
        <div className="freelance-work-content">
          <div className="freelance-work-columns">
            <div className="left-column w-50 text-start">
              <h2>{t("GUIDE_INTRO_WHAT_IS_FREELANCE_TITLE")}</h2>
            </div>
            <div className="right-column">
              <p className="learn-more">
                <a href="#">
                  {t("GUIDE_INTRO_LEARN_MORE")} <img src={rightArrow} alt={t("ARROW")} className="arrow" />
                </a>
              </p>
              <p className="freelance-description">{t("GUIDE_INTRO_WHAT_IS_FREELANCE_DESC")}</p>
            </div>
          </div>

          <div className="freelance-work-grid">
            {services.map((item, i) => (
              <div className="freelance-card" key={i}>
                <img className="icon" src={item.icon}></img>
                <h4>{t(item.title)}</h4>
                <p>{t(item.desc)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default GuideIntro;
